// extracted by mini-css-extract-plugin
module.exports = {"character":"CharcterPage_character__3f6Qc","detail":"CharcterPage_detail__2Kmy0"};